module.exports = __webpack_public_path__ + "media/images/categories/R_logo_hw_red-fabba56577f1c66b61d1c381ad515071.png";